import { AccordionBodyItem, AccordionBodyItemView } from 'component/Accordion';
import React from 'react';

export const RelatedReport = ({ formData, dispatch, hasError }) => {
  const isHAType = formData?.info?.ha_report_id && !formData?.info?.clearance_task_id;
  const reportType = isHAType ? 'HA' : 'TCP';

  let reportId;
  if (isHAType) {
    reportId = formData?.info?.ha_imsma_id;
  } else {
    reportId = formData?.info?.clearance_task_imsma_id || formData?.info?.imsma_id;
  }

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>1.9</span>
        </div>
      )}
      titleUA={`Пов'язаний ${reportType} звіт`}
      titleEN={`Related ${reportType} report`}
      className={hasError ? 'error error-text' : ''}
      children={reportId}
    />
  );
};

export const RelatedReportView = ({ relatedReport }) => {

  const isHAType = relatedReport?.ha_report_id && !relatedReport?.clearance_task_id;
  const reportType = isHAType ? 'HA' : 'TCP';

  let reportId;
  if (isHAType) {
    reportId = relatedReport?.ha_imsma_id;
  } else {
    reportId = relatedReport?.clearance_task_imsma_id || relatedReport?.imsma_id;
  }


  return (
    <AccordionBodyItemView
      accordionSubId="1.9"
      titleUA={`Пов'язаний ${reportType} звіт`}
      titleEN={`Related ${reportType} report`}
      children={reportId}
    />
  );
};
